import { render, staticRenderFns } from "./ly.vue?vue&type=template&id=06b96548&scoped=true&"
import script from "./ly.vue?vue&type=script&lang=js&"
export * from "./ly.vue?vue&type=script&lang=js&"
import style0 from "./ly.vue?vue&type=style&index=0&id=06b96548&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b96548",
  null
  
)

export default component.exports